import { render, staticRenderFns } from "./keywordsAdd.vue?vue&type=template&id=0f94729a&"
import script from "./keywordsAdd.vue?vue&type=script&lang=js&"
export * from "./keywordsAdd.vue?vue&type=script&lang=js&"
import style0 from "./keywordsAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports